import React, { Component } from "react";
import "./style.css";
import PropTypes from "prop-types";

let propsError = "props not defined";
let formatError = "incorrect format";
class Dropdown extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      isMultiSelect: props.isMultiSelect ? props.isMultiSelect : false,
      options: props.options
        ? Array.isArray(props.options)
          ? props.options
          : this.throwError("options " + formatError)
        : this.throwError("options " + propsError),
      option_key: props.option_key
        ? props.option_key
        : this.throwError("option_key " + propsError),
      option_display: props.option_display
        ? props.option_display
        : this.throwError("option_display " + propsError),
      values: props.values
        ? Array.isArray(props.values)
          ? props.values
          : this.throwError("values " + formatError)
        : this.throwError("values " + propsError),
      isSearchOption: props.isSearchOption ? props.isSearchOption : false,
      searchPlaceholder: props.searchPlaceholder
        ? props.searchPlaceholder
        : null,
      displayOption: props.options
        ? Array.isArray(props.options)
          ? props.options
          : this.throwError("options " + formatError)
        : this.throwError("options " + propsError),
      searchValue: "",
      isMenuOpen: false,
      name: props.name ? props.name : this.throwError("name" + propsError),
      simplePlaceholder: props.simplePlaceholder
        ? props.simplePlaceholder
        : this.throwError("simplePlaceholder " + propsError),
      selectAll: props.isMultiSelect ? true : false,
      selectAllText: props.selectAllText ? props.selectAllText : "Select All",
      isFocus: props.isFocus ? true : false,
    };

    this.throwError = this.throwError.bind(this);
    this.onClick = this.onClick.bind(this);
    this.onChange = this.onChange.bind(this);
    this.add = this.add.bind(this);
    this.removeItem = this.removeItem.bind(this);
    this.remove = this.remove.bind(this);
    this.isChecked = this.isChecked.bind(this);
    this.filter = this.filter.bind(this);
    this.toggleDropdownOptions = this.toggleDropdownOptions.bind(this);
    this.selectAll = this.selectAll.bind(this);
    this.focus = this.focus.bind(this);
    this.handleOutsideUserMenuClick = this.handleOutsideUserMenuClick.bind(
      this
    );
  }

  throwError(error) {
    throw new Error(error);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    let selectedValues = [];
    Array.isArray(nextProps.values) &&
      nextProps.values.length > 0 &&
      nextProps.values.map((value) => {
        nextProps.options.map((option) => {
          if (value == option[nextProps.option_key]) {
            selectedValues.push(option);
          }
        });
      });
    return {
      options: nextProps.options,
      values:
        Array.isArray(nextProps.values) && nextProps.values.length == 0
          ? []
          : selectedValues,
    };
  }

  componentDidMount() {
    if (this.state.isFocus) {
      this.firstElement.current.focus();
    }
  }

  focus() {
    this.elementRef.focus();
  }

  onClick() {
    
  }

  add(selectedItemIndex) {
    let values = this.state.isMultiSelect
      ? Object.assign([], this.state.values)
      : [];
    let option = this.state.displayOption[selectedItemIndex];
    values.push(option);

    this.setState({ values: values }, () => {
      let selectedValue = [];
      values.map((value) => {
        selectedValue.push(value[this.state.option_key]);
        this.props.onChange({ name: this.state.name, value: selectedValue });
      });
    });
    if (!this.state.isMultiSelect) {
      this.toggleDropdownOptions();
    }
  }

  removeItem(itemKey) {
    setTimeout(() => {
      let values = Object.assign([], this.state.values);
      let option_key = this.state.option_key;
      let selectedItem = [];

      Array.isArray(this.state.displayOption) &&
        this.state.displayOption.map((option) => {
          if (option[option_key] == itemKey) {
            selectedItem = option;
          }
        });

      Array.isArray(values) &&
        values.map((value, index) => {
          if (selectedItem[option_key] == value[option_key]) {
            values.splice(index, 1);
          }
        });

      this.setState({ values: values }, () => {
        let selectedValue = [];
        values.map((value) => {
          selectedValue.push(value[this.state.option_key]);
          this.props.onChange({ name: this.state.name, value: selectedValue });
        });
      });
    }, 100);
  }

  remove(selectedItemIndex) {
    let values = Object.assign([], this.state.values);
    let option_key = this.state.option_key;
    let selectedItem = this.state.displayOption[selectedItemIndex];

    Array.isArray(values) &&
      values.map((value, index) => {
        if (selectedItem[option_key] == value[option_key]) {
          values.splice(index, 1);
        }
      });

    this.setState({ values: values }, () => {
      this.props.onChange({ name: this.state.name, value: values });
    });
  }

  onChange(index, isChecked) {
    if (isChecked) {
      this.add(index);
    } else {
      this.remove(index);
    }
  }

  isChecked(itemValue) {
    let isFound = this.state.values.some((element) => {
      return element[this.state.option_key] == itemValue;
    });
    return isFound;
  }

  filter(event) {
    let searchValue = event.target.value;
    let option_display = this.state.option_display;
    if (searchValue.length !== 0) {
      let displayOption = this.state.options.filter(function (option) {
        return (
          option[option_display]
            .toUpperCase()
            .indexOf(searchValue.toUpperCase()) > -1
        );
      });
      this.setState({ displayOption: displayOption, searchValue: searchValue });
    } else {
      this.setState({ displayOption: this.state.options, searchValue: "" });
    }
  }

  toggleDropdownOptions() {
    if (!this.state.isMenuOpen) {
      document.addEventListener(
        "click",
        this.handleOutsideUserMenuClick,
        false
      );
    } else {
      // this.node.scrollTo(0, 100)
      // this.node && this.node.focus()
      this.node.focus()
      document.removeEventListener(
        "click",
        this.handleOutsideUserMenuClick,
        false
      );
    }

    this.setState((prevState) => ({
      isMenuOpen: !prevState.isMenuOpen,
      displayOption: this.state.options,
      searchValue: "",
    }));
  }

  handleOutsideUserMenuClick(e) {
    if (this.node && this.node.contains(e.target)) {
      return;
    }
    this.toggleDropdownOptions();
  }

  selectAll(isChecked) {
    let values = isChecked ? Object.assign([], this.state.options) : [];
    this.setState({ values: values }, () => {
      this.props.onChange({
        name: this.state.name,
        value: values.map((value) => value[this.state.option_key]),
      });
    });
  }

  render() {
    return (
      <div
        className={this.state.isMenuOpen ? "multiSelect open" : "multiSelect"}
        id={this.props.id}
        tabIndex="0"
        ref={(node) => {
          this.elementRef = node;
        }}
      >
        <div
          onClick={this.toggleDropdownOptions}
          onBlur={this.toggleDropdownOptions}
          onFocus={this.toggleDropdownOptions}
          className="multiselectInput"
          name={this.props.name}
        >
          {Array.isArray(this.state.values) && this.state.values.length > 0
            ? ""
            : this.context.t(this.state.simplePlaceholder)}
        </div>
        <div
          className="chip"
          ref={(node) => {
            this.node = node;
          }}
        >
          {Array.isArray(this.state.values) && this.state.values.length > 0 && (
            <div
              className={
                this.state.isMultiSelect
                  ? this.state.values.length > 0
                    ? "multi chip-body-main"
                    : "single chip-body-main"
                  : "single chip-body-main"
              }
            >
              {Array.isArray(this.state.values) &&
                this.state.values.length > 0 && (
                  <div className="chip-body">
                    <p className="chip-text">
                      {this.state.values[0][this.state.option_display]}
                    </p>
                  </div>
                )}
              {this.state.isMultiSelect &&
                Array.isArray(this.state.values) &&
                this.state.values.length > 1 && (
                  <div className="chip-count">
                    <span className="counter-value">
                      +{this.state.values.length - 1}
                    </span>
                  </div>
                )}
            </div>
          )}
        </div>
        <div
          className="search-result"
          ref={(node) => {
            this.node = node;
          }}
        >
          {this.state.isSearchOption && (
            <div className="searchInput">
              <input
                type="text"
                name="Search"
                placeholder={
                  this.context.t
                    ? this.context.t(this.state.searchPlaceholder)
                    : this.state.searchPlaceholder
                }
                value={this.state.searchValue && this.state.searchValue}
                onChange={this.filter}
                className="input-box"
              />
              <span className="searchIcon"></span>
            </div>
          )}
          <div
            className={
              !this.state.isMultiSelect
                ? "list-result singleSelect"
                : "list-result"
            }
          >
            {this.state.values &&
              this.state.isMultiSelect &&
              Array.isArray(this.state.values) &&
              this.state.values.length > 0 && (
                <div
                  className="selectedItems"
                  ref={(node) => {
                    this.node = node;
                  }}
                >
                  {this.state.values.map((index, key) => {
                    return (
                      <label
                        className="container"
                        key={index[this.state.option_key]}
                      >
                        {this.state.values[key][this.state.option_display]}
                        <input
                          onChange={(e) => {
                            this.removeItem(
                              this.state.values[key][this.state.option_key]
                            );
                          }}
                          type="checkbox"
                          value={this.state.values[key][this.state.option_key]}
                          name={
                            this.state.values[key][this.state.option_display]
                          }
                          checked={true}
                        />
                        {this.state.isMultiSelect && (
                          <span className="checkmark"></span>
                        )}
                      </label>
                    );
                  })}
                </div>
              )}
            {
              //show select all options
              this.state.selectAll && (
                <label className="container">
                  {this.state.selectAllText}
                  <input
                    type="checkbox"
                    onChange={(e) => {
                      this.selectAll(e.target.checked);
                    }}
                    checked={
                      Array.isArray(this.state.values) &&
                        this.state.values.length == this.state.options.length
                        ? true
                        : false
                    }
                  />
                  <span className="checkmark"></span>
                </label>
              )
            }
            {
              ////show result list
              this.state.displayOption &&
              Array.isArray(this.state.displayOption) &&
              this.state.displayOption.map((options, index) => {
                return (
                  <label
                    className={
                      this.state.isMultiSelect
                        ? "container"
                        : this.isChecked(options[this.state.option_key])
                          ? "container selected"
                          : "container"
                    }
                    key={index}
                  >
                    {options[this.state.option_display]}
                    <input
                      onChange={(e) => {
                        this.onChange(index, e.target.checked);
                      }}
                      key={index}
                      type="checkbox"
                      value={options[this.state.option_key]}
                      name={options[this.state.option_display]}
                      checked={
                        this.isChecked(options[this.state.option_key])
                          ? true
                          : false
                      }
                    />
                    {this.state.isMultiSelect && (
                      <span className="checkmark"></span>
                    )}
                  </label>
                );
              })
            }
          </div>
        </div>
      </div>
    );
  }
}

Dropdown.contextTypes = {
  t: PropTypes.func.isRequired,
};

export default Dropdown;
